import { EHouseMaterial } from '../../../types/jsonQuery';
import * as React from 'react';

import { NonEmptyArray, FOfferType } from '../../../../../JsonQuery';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { Filter } from '../common/Filter';
import { getConstructionTypesList } from './helpers';

interface IConstructionTypeProps {
  offerType: FOfferType;
  value: NonEmptyArray<EHouseMaterial> | null;
  onChange(value: NonEmptyArray<EHouseMaterial> | null): void;
}

export const ConstructionType: React.FC<IConstructionTypeProps> = ({ offerType, value, onChange }) => {
  const constructionTypes = getConstructionTypesList(offerType);

  return (
    <Filter id="advancedFilter_constructionType" label="Тип дома">
      <CheckboxButtonGroupUnselectable options={constructionTypes} value={value} onChange={onChange} />
    </Filter>
  );
};
